import { Link } from "react-router-dom";

export interface Crumb {
  label: string;
  to?: string;
}

interface BreadcrumbsProps {
  items: Crumb[];
}

function Breadcrumbs({ items }: BreadcrumbsProps) {
  return (
    <nav aria-label="面包屑导航" className="text-xs text-foreground-500">
      <ol className="flex flex-wrap items-center gap-2">
        {items.map((item, index) => (
          <li key={`${item.label}-${index}`} className="flex items-center gap-2">
            {item.to ? (
              <Link to={item.to} className="whitespace-nowrap transition-colors hover:text-primary-600">
                {item.label}
              </Link>
            ) : (
              <span className="whitespace-nowrap text-foreground-700">{item.label}</span>
            )}
            {index < items.length - 1 && <i className="ri-arrow-right-s-line text-foreground-400" />}
          </li>
        ))}
      </ol>
    </nav>
  );
}

export default Breadcrumbs;